import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import CompetitionMatches from "../competitionMatches";
import { TYPE } from "../competitionMatches/constants";
import styles from "./critical.scss";

const LABELS = {
  LOAD_MORE: "More matches",
  NO_RESULTS: "No matches matched your search criteria.",
};

const URL_TEMPLATE = "/competition/:competitionId";
const PLACEHOLDER = ":competitionId";

export const UpcomingMatchesSection = ({
  isReady,
  isError,
  competitionId,
  title,
  onGetCompetitions,
  competitions,
}) => {
  const pageSize = useMemo(() => {
    const competition = competitions.find(
      (n) => `${n.id}` === `${competitionId}`
    );

    if (competition) {
      return competition.matchPageSize;
    }

    return null;
  }, [competitionId, competitions]);

  React.useEffect(() => {
    if (!isReady) {
      onGetCompetitions();
    }
  }, [onGetCompetitions, isReady]);

  if (isError) {
    return null;
  }

  if (!isReady) {
    return null;
  }

  return (
    <div important="true">
      <h2 className={styles.title}>{title}</h2>
      <CompetitionMatches
        competitionId={competitionId}
        type={TYPE.UPCOMING}
        noResultsMessage={LABELS.NO_RESULTS}
        pageSize={pageSize}
      />
      <div className={styles.footer}>
        <Link
          to={URL_TEMPLATE.replace(PLACEHOLDER, competitionId)}
          className={styles.readMore}
        >
          {LABELS.LOAD_MORE}
        </Link>
      </div>
    </div>
  );
};
